import keycloakMgr from "./Keycloak";

const clientAuth = {
    headers: function () {
        return {
            headers: {
                Authorization: 'Bearer ' + keycloakMgr.get().token
            }
        };
    }
};

export default clientAuth;
